import React from 'react';
import PropTypes from 'prop-types';

import { Screen } from '@confluence/screen';

import { LazyRouteToRightEditor } from '../lazyComponents';

export const EditBlogRoute = ({ params: { contentId, spaceKey } }) => (
	<Screen
		showPremiumOnboarding={false}
		screenEvent={{ name: 'editPageScreen', id: contentId }}
		pageState={{ contentId, spaceKey, contentType: 'blogpost' }}
	>
		<LazyRouteToRightEditor contentType="blog" contentId={contentId} spaceKey={spaceKey} />
	</Screen>
);

EditBlogRoute.propTypes = {
	params: PropTypes.shape({
		spaceKey: PropTypes.string,
		contentId: PropTypes.string,
	}),
};
